import { render, staticRenderFns } from "./TabApproved.vue?vue&type=template&id=59f995a7"
import script from "./TabApproved.vue?vue&type=script&lang=js"
export * from "./TabApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports